module.exports = __webpack_public_path__ + "static/media/archer_drone_hover.b5a3af93.svg";